import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function Dashboard() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        Dashboard
      </Typography>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center' }}>
        <Typography variant="h3" color="primary" gutterBottom>
          Hello World
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Bienvenue sur le CRM Dashboard
        </Typography>
      </Paper>
    </Box>
  );
}
